import React from 'react';
import { motion } from 'framer-motion';

interface SlideProps {
  isCurrent: boolean;
  children: React.ReactNode;
  slideHeight: number;
}

export const Slide: React.FC<SlideProps> = ({ isCurrent, children, slideHeight }) => {
  return (
    <motion.div
      className="keen-slider__slide h-padding"
      initial={false}
      animate={{
        height: isCurrent ? 'unset' : slideHeight,
      }}
      transition={{
        duration: 0.4,
        type: 'tween',
      }}
    >
      <motion.div
        animate={{
          scale: isCurrent ? 1 : 0.9,
          opacity: isCurrent ? 1 : 0,
        }}
        transition={{
          duration: 0.2,
          type: 'tween',
        }}
      >
        {children}
      </motion.div>
    </motion.div>
  );
};
